import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Layout from "../../../components/dashboard/Layout";
import SearchBar from "../../../containers/admin/mark-schemes/searchbar";
import MarkSchemesTable from "../../../containers/admin/mark-schemes/table";
import AddMarkScheme from "../../../containers/admin/mark-schemes/models/add-mark-scheme";
import { getMarkSchemesBySubjectRequest } from "../../../modules/admin-modules/mark-schemes/Actions";

const MarkSchemes = () => {
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    dispatch(getMarkSchemesBySubjectRequest());
  }, [dispatch]);

  return (
    <Layout>
      <SearchBar searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
      <MarkSchemesTable searchTerm={searchTerm} />
      <AddMarkScheme />
    </Layout>
  );
};

export default MarkSchemes;
